import { cn } from '@repo/design-system/lib/utils';
import { Button } from '@repo/design-system/ui/button';
import { TypingDisplay } from '@repo/design-system/vibe/typing-display';
import { Play } from 'lucide-react';
import Image from 'next/image';

export function HomeHero() {
  return (
    <>
      <div className="mb-8 md:mb-0 md:w-1/2">
        <h1 className={cn('font-medium mb-4 text-6xl leading-normal')}>
          Gestão Inteligente Para
          <TypingDisplay
            duration={100}
            messages={[
              'Restaurantes',
              'Bares',
              'Lanchonetes',
              'Padarias',
              'Pizzarias',
              'Food Trucks',
              'Pastelarias',
              'Temakerias',
              'Cafeterias',
              'Eventos',
              'Sorveterias',
            ]}
            className="p-2 text-[#c5fb00]"
          />
        </h1>
        <div className="mb-8 flex items-center">
          <Image
            src="/images/hero-arrow.svg"
            width={218}
            height={182}
            alt="Arrow"
            className="mr-4"
          />
          <p className="max-w-md pt-8 font-medium text-xl ">
            Simplifique operações, engaje clientes e impulsione o crescimento
            com a solução completa de gestão do seu negócio.
          </p>
        </div>
        <div className="flex items-center">
          <Button className="flex h-12 items-center justify-center rounded-none bg-black p-8 font-bold text-lg text-white hover:text-[#D3F41F]">
            Comece Agora
          </Button>

          <Button
            variant="link"
            className="flex items-center bg-transparent p-8 font-bold text-black text-lg"
          >
            <div className="mr-2 flex h-12 w-12 items-center justify-center rounded-full border-2 border-black bg-[#867BF7] shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] transition-all hover:translate-x-[4px] hover:translate-y-[4px] hover:bg-black hover:shadow-none">
              <Play className="text-white hover:text-lime" />
            </div>
            Conheça a Vibe
          </Button>
        </div>
      </div>
      <div className="relative flex justify-end md:w-1/2">
        <Image
          src="/images/hero.png"
          width={580}
          height={100}
          alt="Foto de um restaurante exemplificando o produto Vibe com os dizeres 'Crescimento Trimentral' e 'Pagamento Recebido'"
        />
      </div>
    </>
  );
}
